import { ChevronDown } from "lucide-react";

export const HeroSection = () => {
  const scrollToAbout = () => {
    const element = document.getElementById("about");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/34770978/pexels-photo-34770978.jpeg"
          alt="Church Community"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/85 via-blue-800/80 to-amber-900/75"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto space-y-6 pt-20">
          <h1
            className="text-4xl sm:text-5xl lg:text-7xl font-bold leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="hero-title"
          >
            Banner of Grace Salvation
            <br />
            <span className="text-amber-300">International Gospel Ministry</span>
          </h1>
          
          <p
            className="text-xl sm:text-2xl text-amber-100 font-light"
            style={{ fontFamily: "'Crimson Text', serif" }}
            data-testid="hero-subtitle"
          >
            A Non-Profit Christian Gospel Ministry
          </p>
          
          <p
            className="text-base sm:text-lg text-blue-100 max-w-2xl mx-auto leading-relaxed"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Spreading the love of Christ and transforming lives through faith, service, and community outreach
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <button
              onClick={() => document.getElementById("donate").scrollIntoView({ behavior: "smooth" })}
              className="px-8 py-4 bg-amber-600 text-white rounded-full font-semibold text-lg hover:bg-amber-700 hover:scale-105 transition-all shadow-lg"
              data-testid="hero-donate-button"
            >
              Support Our Mission
            </button>
            <button
              onClick={() => document.getElementById("programs").scrollIntoView({ behavior: "smooth" })}
              className="px-8 py-4 bg-white/10 backdrop-blur-md text-white border-2 border-white rounded-full font-semibold text-lg hover:bg-white/20 transition-all"
              data-testid="hero-programs-button"
            >
              Our Programs
            </button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <button
          onClick={scrollToAbout}
          className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce"
          data-testid="scroll-indicator"
        >
          <ChevronDown size={40} className="text-amber-300" />
        </button>
      </div>
    </section>
  );
};